import React, { useState, useEffect, useRef } from 'react';
import { ChevronDown } from 'lucide-react';
import './FilterDropdown.css';

const FilterDropdown = ({ value, options, onChange, align = 'left' }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const current = options.find(o => o.value === value) || options[0];

  return (
    <div className="admin-fd" ref={ref}>
      <button type="button" className="admin-fd-btn" onClick={() => setOpen(o => !o)} title={current?.label}>
        <span className="admin-fd-label">{current?.label}</span>
        <ChevronDown size={14} className={`admin-fd-chevron ${open ? 'open' : ''}`} />
      </button>
      {open && (
        <div className={`admin-fd-menu align-${align}`}>
          {options.map(o => (
            <div
              key={o.value}
              className={`admin-fd-option ${o.value === value ? 'active' : ''}`}
              onClick={() => { onChange(o.value); setOpen(false); }}
              title={o.label}
            >
              {o.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default FilterDropdown;